import React from "react";
import { Modal, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import IcX from "../../components/Svg/IcX";
import IcFile from "../../components/Svg/IcFile";
import styleButton from "../Button/Button.module.css";
import styles from "./style.module.css";
import useFormat from "../../hooks/utils/useFormat";

const ModalBudget = props => {
  const { show, closeModal, title, budgets, selected } = props;
  const navigate = useNavigate();

  const { formatDate } = useFormat();

  return (
    <Modal size="lg" show={show} onHide={closeModal} centered>
      <Modal.Header>
        <div as="label" className="d-flex w-100">
          <h2 className="page-title">{title}</h2>
        </div>
        <button className={styles.closeModal} onClick={closeModal}>
          <IcX />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.budgetList}>
          {budgets?.map((__budget, __budget_i) => (
            <Row style={{ backgroundColor: __budget.main && "var(--color-primary-soft" }} key={__budget_i}>
              <Col className={styles.bl_ico} sm={6}>
                <IcFile color={__budget.main && "primary"} />
                <div>
                  <p>
                    {__budget.title} {!!__budget.main && <span className="small-label"> (Principal)</span>}
                  </p>
                  <p className="small-label">{__budget.description}</p>
                </div>
              </Col>
              <Col>
                <p>Criado em:</p>
                <p className="small-label">{formatDate(__budget.created_at, 5)}</p>
              </Col>
              <Col className="justify-content-end d-flex">
                {selected != __budget.id && (
                  <button
                    type="button"
                    className={`${styleButton.button_mini} mt-2`}
                    onClick={() => {
                      navigate(`/business/budget/${__budget.commercial_id}/${__budget.id}`);
                      closeModal(false);
                    }}
                  >
                    <span>Ver</span>
                  </button>
                )}
              </Col>
            </Row>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalBudget;
